<template>
	<BaseInput
		ref="BaseInput"
		v-model="model"
		:disabled="disabled"
		:error-message="errorMessage"
		:is-toggleable="isToggleable"
		:label="label"
		:name="label"
		:placeholder="placeholder"
		:required="required"
		type="email"
		validationtype="email"
	/>
</template>

<script>
import BaseInput from '@/components/forms/inputs/BaseInput';
import Validate from '@/mixins/Validate';

export default {
	name: 'EMailInput',
	mixins: [Validate],
	components: { BaseInput },
	inheritAttrs: false,
	props: {
		isToggleable: { default: false },
		label: { required: true },
		errorMessage: {},
		required: {},
		placeholder: {},
		disabled: {},
		value: {},
	},
	computed: {
		model: {
			get() {
				return this.value;
			},
			set(v) {
				this.$emit('input', v);
			},
		},
	},
};
</script>
